import { apiClient } from "./client";

export type FeedbackEnvironment = "local" | "dev" | "prod";
export type FeedbackKind = "issue" | "error" | "observation";
export type FeedbackSeverity = "low" | "medium" | "high" | "blocker";
export type FeedbackStatus = "received" | "jira_created" | "jira_failed";

export interface FeedbackScreenshot {
  data_url: string;
  content_type: string;
  width?: number;
  height?: number;
}

export interface FeedbackEvent {
  type: string;
  at?: string;
  label?: string;
  path?: string;
  message?: string;
  metadata?: Record<string, unknown>;
}

export interface FeedbackReport {
  environment: FeedbackEnvironment;
  kind: FeedbackKind;
  severity: FeedbackSeverity;
  title: string;
  description: string;
  page: Record<string, unknown>;
  client: Record<string, unknown>;
  events: FeedbackEvent[];
  screenshot?: FeedbackScreenshot | null;
}

export interface FeedbackResponse {
  id: string;
  status: FeedbackStatus;
  jira_key?: string | null;
  jira_url?: string | null;
  message: string;
}

export function submitFeedbackReport(report: FeedbackReport): Promise<FeedbackResponse> {
  return apiClient<FeedbackResponse>("/feedback", {
    method: "POST",
    body: report,
  });
}
